import React from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { DISCOUNT_OPTIONS } from '../../constants';

const DiscountSelector = ({ value, onChange, disabled = false, size = 'small', ...props }) => {
  return (
    <FormControl fullWidth size={size} disabled={disabled}>
      <Select
        value={value !== undefined && value !== null ? value : 0}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        {...props}
      >
        {DISCOUNT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DiscountSelector;
